export const FETCH_PROFILE_REQUEST = 'FETCH_PROFILE_REQUEST';
export const FETCH_PROFILE_SUCCESS = 'FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILURE = 'FETCH_PROFILE_FAILURE';

export const FOLLOW_PROFILE_REQUEST = 'FOLLOW_PROFILE_REQUEST';
export const FOLLOW_PROFILE_SUCCESS = 'FOLLOW_PROFILE_SUCCESS';
export const FOLLOW_PROFILE_FAILURE = 'FOLLOW_PROFILE_FAILURE';


export const SEND_MESSAGE_REQUEST = 'SEND_MESSAGE_REQUEST';
export const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
export const SEND_MESSAGE_FAILURE = 'SEND_MESSAGE_FAILURE';


